import './vendor';

import "./pages/news";
import "./pages/media";
import "./pages/main";


// WEBPACK FOOTER //
// ./src/js/main.js